import { chatApi } from './api'

/** Attaches the chat API module to `_fwn.chat`. */
export function attach() {
  if (
    typeof window !== 'undefined' &&
    !Object.prototype.hasOwnProperty.call(window._fwn, 'chat')
  ) {
    Object.defineProperty(window._fwn, 'chat', {
      value: chatApi,
      writable: false,
    })
  }
}
